'use client';

import { useEffect } from 'react';

const ChatwootWidget: React.FC = () => {
  useEffect(() => {
    const BASE_URL = process.env.NEXT_PUBLIC_CHATWOOD_URL as string;
    const WEBSITE_TOKEN = process.env.NEXT_PUBLIC_CHATWOOD_TOKEN as string;

    (function (d, t) {
      const g = d.createElement(t) as HTMLScriptElement,
        s = d.getElementsByTagName(t)[0];
      g.src = `${BASE_URL}/packs/js/sdk.js`;
      g.defer = true;
      g.async = true;
      s.parentNode?.insertBefore(g, s);

      g.onload = function () {
        if (window.chatwootSDK) {
          window.chatwootSDK.run({
            websiteToken: WEBSITE_TOKEN,
            baseUrl: BASE_URL,
          });
        }
      };
    })(document, 'script');
  }, []);

  return null;
};

const openChatwoot = () => {
  if (window.$chatwoot) {
    window.$chatwoot.toggle('open');
  } else {
    console.error('Chatwoot SDK is not loaded.');
  }
};

export { openChatwoot };
export default ChatwootWidget;
